import { pinGroup as apiPinGroup } from 'APP/model/group/groupModel';
import Entities from 'STORE';

interface IPinGroupParams {
  groupId: string;
}

export async function pinGroup(data: IPinGroupParams): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(data.groupId);
  if (!group) {
    return;
  }

  const newPinOrder = Math.max(...Entities.GroupsStore.groups.map((group) => group.pinOrder));
  group.pinOrder = newPinOrder + 1;

  try {
    const result = await apiPinGroup(data);
    if (!result) {
      group.pinOrder = 0;
    }
  } catch {
    group.pinOrder = 0;
  }
}
